import { Reveal } from "@/components/motion/Reveal";

export const PageHeader = ({ eyebrow, title, sub, children }) => (
  <section className="relative overflow-hidden bg-brand-navy pt-14 pb-16 lg:pt-18 lg:pb-20">
    <div className="absolute inset-0 bg-dotgrid opacity-50" />
    <div className="absolute -top-20 -right-20 w-[420px] h-[420px] rounded-full bg-brand-red/10 blur-3xl" />
    <div className="relative container-x">
      {eyebrow && (
        <Reveal>
          <span className="eyebrow text-brand-red">
            <span className="inline-block h-px w-7 bg-brand-red" />
            {eyebrow}
          </span>
        </Reveal>
      )}
      <Reveal delay={0.05}>
        <h1 className="mt-4 font-display font-black tracking-tight text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.02] max-w-3xl">
          {title}
        </h1>
      </Reveal>
      {sub && (
        <Reveal delay={0.12}>
          <p className="mt-5 text-lg sm:text-xl text-white/70 leading-relaxed max-w-2xl">{sub}</p>
        </Reveal>
      )}
      {children && <div className="mt-8">{children}</div>}
    </div>
  </section>
);
